module.exports = __webpack_public_path__ + "static/media/eye.1deb5627.png";